const assignment1 = () => {
  return (
    <div className="h-full bg-slate-200 flex justify-center">
      <div className="px-4 py-2 w-[650px] bg-white">
        I successfully created my first document
      </div>
    </div>
  );
};

export default assignment1;
